var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9278 11.5891L0.590937 0.0458896C0.504212 -0.000899859 0.404733 -0.011909 0.310356 0.0128618C0.0935434 0.0706605 -0.0416457 0.30736 0.0119198 0.544059L2.21065 10.2377C2.24381 10.3836 2.34329 10.5019 2.47593 10.5487L6.24337 11.9442L2.47848 13.3396C2.34584 13.3891 2.24637 13.5047 2.21576 13.6506L0.0119198 23.358C-0.0110369 23.4599 -0.000833813 23.5672 0.0425287 23.658C0.142007 23.8755 0.386878 23.9635 0.590937 23.8562L21.9278 12.379C22.0069 12.3377 22.0707 12.2662 22.1115 12.1836C22.211 11.9634 22.1294 11.6992 21.9278 11.5891ZM2.52695 20.6002L3.80997 14.9414L11.3397 12.1533C11.3984 12.1313 11.4469 12.0818 11.4673 12.0157C11.503 11.9001 11.4469 11.7763 11.3397 11.735L3.80997 8.94964L2.53205 3.31289L18.5507 11.9799L2.52695 20.6002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactbutton);
export default __webpack_public_path__ + "static/media/contactbutton.73e703090ab33d4f42446139d1583e58.svg";
export { ForwardRef as ReactComponent };